// File: frontend/src/components/marketing/StructuredData.js
//
// schema.org JSON-LD for the public pages. It is rendered inline in the page
// body, so the prerendered HTML carries it to crawlers that run no JavaScript.
//
// Only facts already public elsewhere on the site: the operating company and
// country (Terms and Privacy Notice), the support line (config/publicSupport.js)
// and what the product does. No ratings, review counts, prices, opening hours,
// coordinates or street address. None of those are published anywhere, so none
// may appear here.

import React from "react";
import { MAIN_ORIGIN } from "../../config/origins";
import { SUPPORT_PHONE_E164 } from "../../config/publicSupport";

export function organizationLd() {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${MAIN_ORIGIN}/#organization`,
    name: "PesaFii",
    legalName: "Agrinal Enterprises Limited",
    url: `${MAIN_ORIGIN}/`,
    logo: `${MAIN_ORIGIN}/logo512.png`,
    address: { "@type": "PostalAddress", addressCountry: "UG" },
    contactPoint: [{
      "@type": "ContactPoint",
      telephone: SUPPORT_PHONE_E164,
      contactType: "customer support",
      areaServed: "UG",
      availableLanguage: ["en"],
    }],
  };
}

export function softwareApplicationLd() {
  return {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: "PesaFii",
    url: `${MAIN_ORIGIN}/`,
    applicationCategory: "BusinessApplication",
    operatingSystem: "Web",
    description:
      "Hotspot billing and network management for Wi-Fi businesses: sell internet packages and vouchers, collect MTN Mobile Money and Airtel Money payments, manage MikroTik routers and track revenue.",
    publisher: { "@id": `${MAIN_ORIGIN}/#organization` },
  };
}

// JSON.stringify does not escape "<", so a value containing "</script>" could
// end the element early. Escaping it keeps the JSON valid and the tag closed.
const serialise = (data) => JSON.stringify(data).replace(/</g, "\\u003c");

export default function StructuredData({ data }) {
  return (
    <script
      type="application/ld+json"
      // Built from the constants above only; never from visitor input.
      dangerouslySetInnerHTML={{ __html: serialise(data) }}
    />
  );
}
